import '@babel/polyfill'
import Vue from 'vue'
import 'mutationobserver-shim'
import './Utils/fliter'
// import './config/firebase'
import App from './App.vue'
import router from './router'
import store from './store'
import Raphael from 'raphael/raphael'
import './plugins'
import './registerServiceWorker'
import AlgoliaComponents from 'vue-instantsearch'
import i18n from './i18n'
import './directives'
import { ApolloLink, concat } from 'apollo-link';
import { ApolloClient } from 'apollo-client';
import { HttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import VueApollo from 'vue-apollo';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import VueFormulate from '@braid/vue-formulate'
import VueApexCharts from 'vue-apexcharts'
import JsonCSV from 'vue-json-csv'
import { accessToken } from './Utils/auth';
import { getPermissions, getAllowedRoutes } from './Utils/account'

const AclPlugin = {
  // eslint-disable-next-line no-unused-vars
  install(Vue, options) {
    // $acl checks is incoming string in pattern table.action.columns are allowed
    Vue.prototype.$acl = function (s) {
      const tokens = s.split(".")
      if (tokens.length !== 3) {
        return false
      }

      const [entity, action, column] = tokens;
      const permissions = getPermissions();

      for (const permission of permissions) {
        // if table and action found, continue with check
        if (permission.table === entity && permission.action === action) {
          // if "*", always allow, otherwise check particular column
          if (column === "*") {
            return true
          } else {
            if (permission.columns.includes(column)) {
              return true
            } else {
              return false
            }
          }
        }
      }

      return false;
    }

    Vue.prototype.$allowedRoute = function (r) {
      const allowedRoutes = getAllowedRoutes();

      if (allowedRoutes.includes(r)) {
        return true
      }

      return false
    }

    Vue.prototype.$account = "default-string";
  }
};

console.log(`hash ${process.env.VUE_APP_GIT_HASH}, build time ${process.env.VUE_APP_BUILD_TIME}`)

global.Raphael = Raphael

Vue.use(AclPlugin)
Vue.use(AlgoliaComponents)
Vue.use(VueToast);
Vue.use(VueFormulate, {
  classes: {
    outer: 'form-group',
    input: 'form-control',
    inputHasErrors: 'is-invalid',
    help: 'form-text text-muted',
    errors: 'list-unstyled text-danger'
  }
})
VueFormulate.extend({
  rules: {
    isJson: ({ value }) => {
      try {
        JSON.parse(value);
        return true;
      } catch (e) {
        return false;
      }
    },
  },
});
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
Vue.component('downloadCsv', JsonCSV)
Vue.filter('notAvailable', function (value) {
  if (value || value === 0) {
    return value
  } else {
    return '-'
  }
})
Vue.filter('formatPercentage', function (value) {
  if (value) {
    return Math.round(value * 100)
  } else {
    return '-'
  }
})
Vue.filter('formatCurrency', function (value) {
  if (value) {
    return value.toLocaleString('cs')
  } else {
    return '-'
  }
})
Vue.filter('customFieldColumnName', function (value) {
  return value.replaceAll('_', ' ')
})
Vue.filter('formatUser', function (value) {
  if (value.first_name && value.last_name && value.email) {
    return `${value.first_name} ${value.last_name} (${value.email})`
  }
  if (value.email) {
    return value.email
  }
  return "NOT DEFINED"
})

Vue.config.productionTip = false

// ==========
// APOLLO
// ==========

const httpLink = new HttpLink({
  uri: process.env.VUE_APP_GQL_API_URL
});

const authMiddleware = new ApolloLink((operation, forward) => {
  // add the authorization to the headers
  if (accessToken()) {
    operation.setContext({
      headers: {
        "Authorization": `Bearer ${accessToken()}`
      }
    });
  }

  return forward(operation);
})


const apolloClient = new ApolloClient({
  link: concat(authMiddleware, httpLink),
  cache: new InMemoryCache(),
  connectToDevTools: true,
  defaultOptions: {
    $query: {
      loadingKey: 'loading',
    }
  }
});

Vue.use(VueApollo);

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
});

const vm = new Vue({
  router,
  apolloProvider,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')

window.vm = vm
